import "./Paragraph.css";

export default function Paragraph({ children, weak, strong, style }) {
    if (weak) style = { color: "var(--yona-color-50)", ...style };
    if (strong) style = { fontWeight: "bold", ...style };

    return (<p style={style} className="yona-paragraph">{children}</p>);
}